import React, { useState } from 'react';
import { ResponsiveHeatMap } from '@nivo/heatmap';
import { Container } from '@material-ui/core';

import { toddowChartDataObject } from '../../@types/chartData';
import './style.css';

interface ChartData {
  legendaY?: string;
  year: string;
  nDead: string;
  uv?: number;
  pv?: number;
  wv?: number;
}

interface legendsProps {
  legendY?: string;
  legendOne?: string;
  data?: ChartData[];
  dataHeatMap: toddowChartDataObject[] | [];
}

interface Data {
  yKey: string;
  xKey: string;
  value: number;
}

const HeatMapChart: React.FC<legendsProps> = ({ dataHeatMap }) => {
  const keys: string[] = [];
  const [active, setActive] = useState<boolean>(false);
  const [object, setObject] = useState<Data>({
    yKey: '',
    xKey: '',
    value: 0,
  });

  for (let keysValue = 0; keysValue <= 23; keysValue += 1) {
    keys.push(`${keysValue}`);
  }
  const makeHeat = (): JSX.Element => {
    if (!dataHeatMap || dataHeatMap[0] === undefined || dataHeatMap === []) {
      return <div>Dados incorretos</div>;
    }

    const handleAddAbout = (data: any, event: any) => {
      setObject({
        yKey: data.yKey,
        xKey: data.xKey,
        value: data.value,
      });
      setActive(true);
    };

    return (
      <Container className="RootMap">
        <ResponsiveHeatMap
          data={dataHeatMap}
          keys={keys}
          indexBy="indexBy"
          margin={{ right: 60, bottom: 70, left: 60 }}
          forceSquare
          sizeVariation={0.1}
          colors={process.env.REACT_APP_TRANSITAR_COLOR === 'true' ? 
            ['#f1f2f2', '#93cfc9', '#38c7bb', '#00A194', '#008075', '#044a44']
            :
            ['#f1f2f2', '#f6edb1', '#f5e684', '#ecbe1d', '#e88300', '#68101a']
          }
          axisTop={{
            orient: 'top',
            tickSize: 0,
            tickPadding: 15,
            tickRotation: 0,
            legend: '',
            legendOffset: 36,
          }}
          axisRight={null}
          axisBottom={null}
          axisLeft={{
            orient: 'left',
            tickSize: 0,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: -40,
          }}
          tooltip={({ xKey, yKey, value }) => (
            <strong style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>
              {yKey === 'DOM' && (
                <>
                  Domingo, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'SEG' && (
                <>
                  Segunda, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'TER' && (
                <>
                  Terça, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'QUA' && (
                <>
                  Quarta, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'QUI' && (
                <>
                  Quinta, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'SEX' && (
                <>
                  Sexta, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
              {yKey === 'SÁB' && (
                <>
                  Sábado, {xKey}h às {Number(xKey) + 1 === 24 ? '0' : Number(xKey) + 1}h:{' '}
                  {value} ocorrências
                </>
              )}
            </strong>
          )}
          theme={{
            tooltip: {
              container: {
                background: 'white',
                color: '#000',
              },
            },
          }}
          cellOpacity={1}
          cellBorderWidth={1}
          cellBorderColor="#cecece"
          labelTextColor={{ from: 'color', modifiers: [['opacity', 1.8]] }}
          animate={false}
          motionStiffness={80}
          motionDamping={9}
          hoverTarget="cell"
          cellHoverOthersOpacity={0.25}
          onClick={() => handleAddAbout}
        />
        {active ? (
          <p className="pModal">
            {object.yKey === 'DOM' && (
              <span>
                Domingo, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'SEG' && (
              <span>
                Segunda, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'TER' && (
              <span>
                Terça, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'QUA' && (
              <span>
                Quarta, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'QUI' && (
              <span>
                Quinta, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'SEX' && (
              <span>
                Sexta, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
            {object.yKey === 'SÁB' && (
              <span>
                Sábado, {object.xKey}h às{' '}
                {Number(object.xKey) + 1 === 24 ? '0' : Number(object.xKey) + 1}h:{' '}
                {object.value} ocorrências
              </span>
            )}
          </p>
        ) : (
          <></>
        )}
      </Container>
    );
  };
  return <>{makeHeat()}</>;
};

export default HeatMapChart;
